import { subscribeChannel } from './duplexer-actions';
import { DUPLEXER_CHANNELS } from '../../universal/constants/duplexer';

export function emitForumOpened() {
  return (dispatch) => {
    dispatch(subscribeChannel({ channelName: DUPLEXER_CHANNELS.FORUM }));
  };
}
